/* eslint-disable lingui/no-unlocalized-strings */
import { ArrowUpRight, Video } from "lucide-react";

export const EcosystemBridgeSection = () => (
  <section className="folio-recruit">
    <div className="folio-shell recruit-strip">
      <span className="recruit-mark">
        <Video size={24} />
      </span>
      <div>
        <p className="folio-eyebrow">Interviews requested by real recruiters</p>
        <h2>When the invitation comes, take the next step here.</h2>
        <p>
          Hiring teams using theRecruit can send you interview invitations for their roles. Complete
          the AI-conducted interview on theResume—this time as part of a real hiring process.
        </p>
      </div>
      <a
        className="folio-text-link"
        href="https://recruit.theresume.io"
        target="_blank"
        rel="noopener noreferrer"
      >
        Meet theRecruit <ArrowUpRight size={18} />
      </a>
    </div>
  </section>
);
